import PublicationCreateProject from "./PublicationCreateProject";
import SelectLocation from "./SelectLocation";
import PublicationPreview from "./PublicationPreview";
import PublicationPreviewAvatar from "./PublicationPreviewAvatar";
import PublicationSuccess from "./PublicationSuccess";
import PublicationSliderGallery from "./PublicationSliderGallery";
import PublicationDonations from "./PublicationDonations";
import PublicationEdit from "./PublicationEdit";

const createProject = [

    {
        title: 'publication_project_choose_category',
        progress: { title: 'publication_project_progress_category', step: 2 },
        component: PublicationCreateProject, valid: true, required: true,
    },

    {
        title: 'publication_project_location',
        progress: { title: 'publication_project_progress_region', step: 3 },
        component: SelectLocation, valid: true, required: true,
    },

    {
        title: 'publication_project_enter_ad_text',
        progress: { title: 'publication_project_progress_ad_text', step: 4 },
        component: PublicationPreview, valid: true, required: true,
    },

    {
        title: 'publication_project_upload_profile_photo',
        progress: { title: 'publication_project_progress_profile_photo', step: 5 },
        component: PublicationPreviewAvatar, valid: true, required: true,
    },

    {
        title: 'publication_project_upload_gallery_photos',
        progress: { title: 'publication_project_progress_ad_photos', step: 6 },
        component: PublicationSliderGallery, valid: true, required: true,
    },

    {
        title: 'publication_project_fundraising_optional',
        progress: { title: 'publication_project_progress_fundraising', step: 7 },
        component: PublicationDonations, valid: true, required: true,
    },

    {
        title: 'publication_project_check_entered_data',
        progress: { title: 'publication_project_progress_check_data', step: 8 },
        component: PublicationEdit, valid: true, required: true,
    },

    {
        progress: { title: 'publication_project_progress_thanks', step: 9 },
        component: PublicationSuccess, valid: true, required: true,
    },


];

export default createProject;
